module.exports = __webpack_public_path__ + "img/cayman-islands.6800896b.svg";